module.exports = __webpack_public_path__ + "img/refer2.png";